/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/remove': {
    width: 17,
    height: 16,
    viewBox: '0 0 17 16',
    data: '<path pid="0" _fill="#B2B2B2" fill-rule="evenodd" d="M8 16A8 8 0 108 0a8 8 0 000 16zm1.423-8l2.121-2.121-1.414-1.415-2.12 2.122-2.122-2.122L4.473 5.88 6.595 8l-2.122 2.121 1.415 1.415 2.12-2.122 2.122 2.122 1.414-1.415L9.424 8z" clip-rule="evenodd"/>'
  }
})
